import React from "react";

const Terms_Conditions = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-9">

          {/* Page Header */}
          <div className="text-center mb-5">
            <h1 className="fw-bold text-dark mb-3">
              Terms & Conditions
            </h1>
            <p className="text-muted border-top border-bottom py-3 mx-auto" style={{ maxWidth: '400px' }}>
              Last updated on November 13, 2025
            </p>
          </div>

          {/* Introduction */}
          <div className="mb-5 p-4 bg-info bg-opacity-10 border-start border-3 border-info rounded-end">
            <div className="mb-4 text-start">
              <h5 className="text-dark mb-2">MyFoodMyPrice is a product of Biryani Palayam.</h5>
              <p className="fs-6 text-dark mb-0">
                Click here to visit{" "}
                <a href="https://www.biryanipalayam.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-primary fw-semibold border-bottom border-primary">
                  Biryani Palayam
                </a>
              </p>
            </div>
            <p className="fs-5 mb-0 text-dark">
              Biryani Palayam, as the owner and operator of MyFoodMyPrice (referred to as "Biryani Palayam", "we", "us", or "our"), provides the MyFoodMyPrice website, application, and related services to users and visitors (referred to as "you" or "your"). Your access to and use of MyFoodMyPrice is subject to these Terms & Conditions, our Privacy Policy, and any other applicable policies, notices, or terms relating to specific features or services.
            </p>
          </div>

          {/* Welcome Section */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: '36px', height: '36px' }}>
                  1
                </span>
                Welcome & Agreement
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">✓</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Welcome to MyFoodMyPrice, a product of Biryani Palayam. By accessing, browsing, registering for, or using the MyFoodMyPrice website, application, or related services, you agree to comply with and be bound by these Terms & Conditions and our Privacy Policy. If you do not agree with these terms, please discontinue use of the Service.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Definitions */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: '36px', height: '36px' }}>
                  2
                </span>
                Definitions
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    The term "MyFoodMyPrice" refers to the product, website, application, and online platform owned and operated by Biryani Palayam.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    The term "Biryani Palayam", "Company", "us", "we", or "our" refers to the owner and operator of MyFoodMyPrice, whose registered/operational office is: <br/><br/>
                    <strong>3rd Floor, Hamid Complex, No. 190 - 192, Opp. Ibis Hotel, Anna Salai, Thousand Lights, Chennai, Tamil Nadu 600006.</strong>
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    The term "Service" refers to the MyFoodMyPrice website, application, platform, features, products, and related services provided by Biryani Palayam.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">•</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    The term "you" or "your" refers to any person accessing, browsing, registering for, or using the Service.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Terms of Use */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: '36px', height: '36px' }}>
                  3
                </span>
                Terms of Use
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">1</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    The content and features of MyFoodMyPrice are provided for your information and use and may be updated, modified, suspended, or changed from time to time without prior notice, subject to applicable law.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">2</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Neither we nor any third parties provide any warranty or guarantee regarding the accuracy, timeliness, performance, completeness, availability, or suitability of information, materials, products, or services made available through MyFoodMyPrice for any particular purpose. You acknowledge that such information or materials may contain inaccuracies or errors, and liability for such inaccuracies or errors is excluded to the fullest extent permitted by applicable law.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">3</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Your use of information, materials, products, and services available through MyFoodMyPrice is at your own discretion and risk. It is your responsibility to determine whether the products, services, or information available through the Service meet your requirements.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">4</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    MyFoodMyPrice contains materials owned by or licensed to Biryani Palayam, including but not limited to the design, layout, branding, text, graphics, images, logos, and other content. Unauthorized reproduction, distribution, modification, or commercial use of such materials is prohibited except where permitted by law or with prior written authorization.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">5</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Any third-party trademarks, logos, or intellectual property displayed through the Service remain the property of their respective owners and are acknowledged accordingly.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">6</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Unauthorized, unlawful, fraudulent, abusive, or disruptive use of MyFoodMyPrice is prohibited and may result in restriction or termination of access and/or legal action as permitted by applicable law.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">7</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    MyFoodMyPrice may contain links to third-party websites or services. These links are provided for convenience or additional information. Biryani Palayam does not control third-party websites and is not responsible for their content, availability, security, terms, or privacy practices.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">8</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    You may not create links to, reproduce, frame, or commercially use MyFoodMyPrice content in a manner that falsely suggests association, endorsement, or authorization without prior written consent from Biryani Palayam.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-warning bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">9</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Your use of MyFoodMyPrice and any dispute arising from or relating to the Service or these Terms & Conditions shall be governed by the applicable laws of India, subject to the jurisdiction and requirements of applicable courts and regulatory authorities.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Merchant Liability */}
          <div className="card border-0 shadow-sm rounded-3">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark d-flex align-items-center">
                <span className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: '36px', height: '36px' }}>
                  4
                </span>
                Merchant Liability
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-dark bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: '24px', height: '24px' }}>
                    <span className="fw-bold">!</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Biryani Palayam, as the owner and operator of MyFoodMyPrice and as the merchant where applicable, shall not be liable for losses or damages arising directly or indirectly from the decline of authorization for a transaction where such decline results from limits, restrictions, verification requirements, or authorization decisions imposed by the cardholder's bank, payment provider, acquiring bank, or other financial institution, to the fullest extent permitted by applicable law.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Terms_Conditions;